import { render } from "./back-in-stock.vue?vue&type=template&id=ad908014"
import script from "./back-in-stock.vue?vue&type=script&lang=js"
export * from "./back-in-stock.vue?vue&type=script&lang=js"

import "./back-in-stock.vue?vue&type=style&index=0&id=ad908014&lang=scss"

import exportComponent from "/Users/ian/codebase/toteme-2023/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__